import React from 'react';

import { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';

import { Col, Container, FormLabel, Row, Form, Table, Card } from 'react-bootstrap';
import { ApiDelete, ApiGet, ApiPatch, ApiPost } from '../../helper/API/ApiData';
import { useForm } from "react-hook-form"
import FormInput from '../../components/form/FormInput';

import { toast } from 'react-toastify';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import { handleError } from '../../utils/helper';
import { TabPanel, TabView } from 'primereact/tabview';


interface FieldOption {
    field: {
        type: string;
    }

}

type Member = {
    id: string,
    name: string,
    contact_number: string,
    age: number,
    groupDetails: null | {},
    selected?: boolean
}



const AddUpdateShg = () => {

    const { id } = useParams()
    const isUpdateRequest = !!id

    const navigate = useNavigate()

    const [fields, setFields] = useState({})
    const [members, setMembers] = useState<Member[]>([])
    const [selectedMembers, setSelectedMembers] = useState<Member[]>([])
    const [globalFilterValue, setGlobalFilterValue] = useState("")
    const [currentMembers, setCurrentMembers] = useState<Member[]>([])

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
        setValue,
        setError,
    } = useForm()

    const onSubmit = (data: any) => {
        // Check if members are less than 9
        // Raise validation error if thats the case
        // if (isUpdateRequest) {
        //     if (selectedMembers.length + currentMembers.length < 10) {
        //         toast.error("Please add atleast 10 members")
        //         return
        //     }

        // }
        // else if (selectedMembers.length <= 10) {
        //     toast.error("Please add at least 10 members")
        //     return
        // }

        data['selectedMembers'] = selectedMembers

        if (isUpdateRequest) {
            ApiPatch(`shg/${id}`, data)
                .then((res: any) => {
                    if (res.status === 200) {
                        toast.success("Successfully updated shg")
                        navigate('/shgadmin/shg')
                        // navigate('shgadmin/shg/')
                    }
                }).catch((error) => {
                    if (error.status === 400 && error.code === 'validation_error') {
                        error.data.validation.body.keys
                        setError(error.data.validation.body.keys[0],
                            { type: "server", message: error.data.validation.body.message },
                            { shouldFocus: true })
                    }
                    return error
                })
        }
        else {
            ApiPost('shg/add', data)
                .then((res: any) => {
                    if (res.status === 200) {
                        toast.success("Successfully created shg")
                        // Clear all fields
                        reset()
                        navigate('/shgadmin/shg')

                    }
                }).catch((error) => {
                    if (error.status === 400 && error.code === 'validation_error') {
                        error.data.validation.body.keys
                        setError(error.data.validation.body.keys[0],
                            { type: "server", message: error.data.validation.body.message },
                            { shouldFocus: true })
                    }
                    return error
                })
        }

    }
    useEffect(() => {

        // Getching field names
        ApiGet('shg/add')
            .then((res: any) => {
                if (res?.status === 200) {
                    setFields(res.data)
                    if (isUpdateRequest) {
                        // Get shg instance
                        ApiGet(`shg/id/${id}`)
                            .then((res: any) => {
                                if (res?.status === 200) {
                                    const shgData = res.data[0]
                                    Object.keys(shgData).map((key) => {
                                        setValue(key, shgData[key], { shouldValidate: true, shouldTouch: true });
                                    })
                                }
                            })
                            .catch((error) => {
                                return error
                            })
                    }
                }
            })
            .catch((error) => {
                return error
            })

        // Fetching available members
        ApiGet('member')
            .then((res: any) => {
                if (res?.status === 200) {
                    const currentMembers: Member[] = []
                    const availableMembers: Member[] = []
                    res.data.forEach((member: any) => {
                        const reducedMember = {
                            id: member.id,
                            name: member.name,
                            contact_number: member.contact_number,
                            age: member.age,
                            groupDetails: member.groupDetails,
                        }
                        if (member.groupDetails[0]?.shg?.id === id) {
                            currentMembers.push(reducedMember)
                        }
                        else if (member.selected && member.groupDetails.length === 0) {
                            availableMembers.push(reducedMember)
                        }
                    })
                    // const currentMembers = reduced_data.filter((member: any) => member.groupDetails[0]?.shg?.id === id)
                    // const member_data = reduced_data.filter((member: any) => (member.groupDetails.length === 0 && member.selected))

                    setMembers(availableMembers)

                    setCurrentMembers(currentMembers)
                }
            })
            .catch((error) => {
                handleError(error)
                return error
            })

        initFilters();

    }, [])


    const handleDeleteMember = (memberId: string) => {

        // Check if the current member length is greater than 10
        // if (currentMembers.length <= 10) {
        //     toast.error("Cannot delete members as the count of member is less than 10")
        //     return
        // }

        ApiDelete(`shg/${id}/member/${memberId}`, { "id": id })
            .then((res: any) => {
                if (res.status === 200) {
                    toast.success("Successfully deleted the member from the group")
                    // Refetch the shg list
                    const deletedMember: Member | undefined = currentMembers.find((member: Member) => member.id === memberId)
                    setCurrentMembers(currentMember => currentMember.filter((member: any) => member.id !== memberId))

                    const newMembers: any = [...members, deletedMember]
                    setMembers(newMembers)
                }
            })
            .catch((error) => { return error })

    }


    const actionBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <Button type="button" icon="pi pi-trash" style={{ borderRadius: "50%", margin: "10px" }} rounded outlined severity="danger" onClick={() => handleDeleteMember(rowData.id)} />
            </React.Fragment>
        );
    };


    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };


    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </span>
            </div>
        );
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue('');
    };

    return (
        <Container fluid>
            <h3 className='heading-txt m-3'>{isUpdateRequest ? "Update Shg" : "Add Shg"}</h3>
            <Card className="p-3">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='General_Info border-none'>
                        <Row>
                            {Object.entries(fields).map(([fieldName, fieldOptions]: [string, unknown | any], index) => {
                                return (
                                    <Col key={index} xl={4} lg={4} md={6} className="mt-3">
                                        <FormInput name={fieldName} fieldOptions={fieldOptions}
                                            control={control} errors={errors} />
                                    </Col>
                                )
                            })}
                        </Row>

                        {currentMembers.length > 0 && isUpdateRequest &&
                            <Row>
                                <Col xl={12} lg={12} md={12}>
                                    <div className='mt-5 d-flex justify-content-start'>
                                        <h5>Current Members - {currentMembers.length}</h5>
                                    </div>
                                </Col>
                                <Col xl={12} lg={12} md={12} className="mt-3">
                                    <DataTable value={currentMembers} style={{ width: '100%' }} scrollable stripedRows scrollHeight="250px">
                                        <Column field='name' header="Name"></Column>
                                        <Column field='age' header="Age"></Column>
                                        <Column field='contact_number' header="Contact number"></Column>
                                        <Column body={actionBodyTemplate} style={{ maxWidth: '5rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                                    </DataTable>
                                </Col>
                            </Row>
                        }

                        {members.length > 0 &&
                            <Row>
                                <Col xl={12} lg={12} md={12}>
                                    <div className='mt-5 d-flex justify-content-start'>
                                        <h5>Available Members - {members.length}</h5>
                                    </div>
                                </Col>
                                <Col xl={12} lg={12} md={12} className="mt-3">
                                    <DataTable
                                        value={members}
                                        header={renderHeader}
                                        filters={filters}
                                        dataKey="id"
                                        selectionMode={'multiple'}
                                        selection={selectedMembers}
                                        onSelectionChange={(e) => setSelectedMembers(e.value)}
                                        scrollable
                                        scrollHeight="250px">
                                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                                        <Column field='name' header="Name"></Column>
                                        <Column field='age' header="Age"></Column>
                                        <Column field='contact_number' header="Contact number"></Column>
                                    </DataTable>
                                </Col>
                            </Row>
                        }

                        <Row className='d-flex justify-content-center mt-3' >
                            <div className='d-flex justify-content-center'>
                                <Button className='btn' style={{ backgroundColor: "#082979", color: "#fff" }} type="submit" name="submit">
                                    {isUpdateRequest ? "Update Shg" : "Add Shg"}
                                </Button>
                            </div>
                        </Row>
                    </div>
                </form>
            </Card>
        </Container >
    );
};

export default AddUpdateShg;